<template>
  <avs-card
    noTitle
    min-height="80vh"
    class="d-flex flex-column"
  >
    <template v-slot:content>
      <v-stepper
        v-bind="{ ...$attrs }"
        v-on="{ ...$listeners }"
        elevation="0"
        :style="steppersStyle"
      >
        <div class="d-flex align-center mb-6">
          <slot name="headers"></slot>
        </div>

        <v-stepper-items>
          <v-card-text>
            <slot name="items"></slot>
          </v-card-text>
        </v-stepper-items>
      </v-stepper>
      <v-spacer></v-spacer>
      <v-card-actions class="d-flex justify-center">
        <slot name="actions"></slot>
      </v-card-actions>
    </template>
  </avs-card>
</template>

<script>
import { getTheme } from "@/plugins/vuetify"

export default {
  name: "AvsSteppers",
  computed: {
    steppersStyle() {
      return { backgroundColor: getTheme(this).bgCard }
    }
  }
}
</script>
